import * as yup from "yup";
import { validationSchemas } from "./data";
export const productSchema = yup.object().shape({
  productCategory: validationSchemas.numberStringSelectValidation,
  unit: validationSchemas.numberStringSelectValidation,
  productName: validationSchemas.name,
  description: validationSchemas.free,
});
